import { render, staticRenderFns } from "./syBanKuai.vue?vue&type=template&id=485cf888&scoped=true"
import script from "./syBanKuai.vue?vue&type=script&lang=js"
export * from "./syBanKuai.vue?vue&type=script&lang=js"
import style0 from "./syBanKuai.vue?vue&type=style&index=0&id=485cf888&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485cf888",
  null
  
)

export default component.exports